import { Injectable } from '@angular/core'

import { injectAppVersionExportHandlers } from '../actions/app-version-export.handlers'
import { injectAppVersionImportHandlers } from '../actions/app-version-import.handlers'
import { injectBuildExportHandlers } from '../actions/build-export.handlers'
import { injectBuildImportHandlers } from '../actions/build-import.handlers'
import {
  ExtendedNotification,
  NotificationActionHandler,
  NotificationActionType,
} from '../notifications.model'

/**
 * Runs the action a notification offers. Every handler works from the notification alone — its
 * ids and payload — so an action behaves the same from a toast on any page as from the center.
 * Each notification type's handlers come from its own factory in `actions/`; typing the map as a
 * full `Record` makes a type whose handlers are not spread in here a compile error.
 */
@Injectable({ providedIn: 'root' })
export class NotificationActionsService {
  #handlers: Record<NotificationActionType, NotificationActionHandler> = {
    ...injectAppVersionExportHandlers(),
    ...injectAppVersionImportHandlers(),
    ...injectBuildExportHandlers(),
    ...injectBuildImportHandlers(),
  }

  runAction(notification: ExtendedNotification): void {
    if (notification.action) {
      this.#handlers[notification.action.type](notification)
    }
  }
}
